<template>
  <div>
    <v-dialog v-model="value" persistent max-width="600px" width="200px">
      <v-card>
        <div class="custom_container">
          <p>Ocurrio un error</p>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: ['value'],
  data: () => ({
    value: false,
  }),
  methods: {
    close() {
      this.$emit("input", !this.value);
    }
  },
  watch: {
    value(val) {
      if (!val) return
      setTimeout(() => (this.close()), 3000)
    }
  }
}
</script>

<style scoped>
.custom_container {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100px;
}
</style>
